/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * UIBFS User Service API
 * API documentation for UIBFS User Service - handles authentication, user management, and profile operations
 * OpenAPI spec version: 1.0.0
 */

/**
 * Application requesting access.
 */
export type LoginRequestApp =
  (typeof LoginRequestApp)[keyof typeof LoginRequestApp];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LoginRequestApp = {
  MEMBERSHIP_PORTAL: "MEMBERSHIP_PORTAL",
  SPORTS_PORTAL: "SPORTS_PORTAL",
  LEAVE_PORTAL: "LEAVE_PORTAL",
  STUDENTS_PORTAL: "STUDENTS_PORTAL",
  EVENTS_PORTAL: "EVENTS_PORTAL",
} as const;
